import { Component, ElementRef, Renderer2, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { AuthService } from 'src/app/core/auth.service';
import { CommonService } from 'src/app/service/common.service';
import { LoaderService } from 'src/app/service/loader.service';
import { RestService } from 'src/app/service/rest.service';
// import jwt_decode from 'jwt-decode';
import { JwtHelperService } from '@auth0/angular-jwt';
import { ToastrService } from 'ngx-toastr';
import { CommonModule } from '@angular/common';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
declare let google: any;
@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss',
  standalone:true,
  imports:[
    CommonModule,TranslateModule,ReactiveFormsModule,MatFormFieldModule,MatSelectModule,MatCheckboxModule,MatInputModule,
    MatButtonModule

  ]
})
export class SignUpComponent {
  MobileForm!: FormGroup;
  EmailForm!: FormGroup;
  isSubmittedMobile: boolean = false;
  submittedEmail: boolean = false;
  MobileHide: boolean = true;
  phoneCodes: any = [];
  submittedotp: boolean = false;
  showResend: boolean = false;
  interval: any;
  timeRemaining_percent!: number;
  resendCountdown: number = 60;
  timer!: number;
  remainingTime!: any;
  intervalId: any;
  @ViewChild('otpInput') otpInput!: ElementRef;
  otp: string = '';
  oTPID: any;
  emaiauthentication: any;
  OTPForm: FormGroup;
  submitted: boolean = false;

  loginBoolean: boolean = true;
  mfaAuthenticationTypeID: any;
  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private loader: LoaderService,
    private restService: RestService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private route: ActivatedRoute,
    public router: Router,
    private renderer: Renderer2,
    private commonService: CommonService,
    private toastr: ToastrService,
    public dialogRef: MatDialogRef<SignUpComponent>
  ) { }

  ngOnInit(): void {
    this.MobileForm = this.fb.group({
      countryCode: [null, Validators.required],
      phoneNumber: [
        null,
        [
          Validators.required,
          Validators.minLength(9),
          Validators.maxLength(10),
        ],
      ],
    });
    this.EmailForm = this.fb.group({
      email: [
        null,
        [
          Validators.required,
          Validators.email,
          Validators.pattern(
            /^\s*[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\s*$/
          ),
        ],
      ],
    });
    this.OTPForm = this.fb.group({
      otp: [null, Validators.required],
    });
    for (let i = 0; i < 6; i++) {
      this.OTPForm.addControl(
        'otp' + i,
        new FormControl('', Validators.required)
      );
    }
    this.OTPForm.valueChanges.subscribe((value) => {
      this.submittedotp = false;
    });
    this.getMasterCountryCode();
    google.accounts.id.disableAutoSelect();
    google.accounts.id.initialize({
      client_id:
        '895246951258-d7pn93ahp49g2nbqr5n9mbl76gm34r4j.apps.googleusercontent.com',
      callback: this.handleCredentialResponse.bind(this),
      auto_select: false,
      cancel_on_tap_outside: false,
    });
    google.accounts.id.renderButton(
      // @ts-ignore
      document.getElementById('google-button'),
      { theme: 'outline', size: 'large', width: '100%' }
    );

    
  }
  get mobilecontrol() {
    return this.MobileForm.controls;
  }
  get controlEmail() {
    return this.EmailForm.controls;
  }
  get b() {
    return this.OTPForm.controls;
  }
  MobileFormSubmit() {
    this.isSubmittedMobile = true;
    if (this.MobileForm.invalid) {
      return;
    }
    this.loader.show();
    let params: any = {};
    params.emailID = null;
    (params.phoneNumber = this.MobileForm.controls.phoneNumber.value),
      (params.countryCodeID = this.MobileForm.controls.countryCode.value);
    let url = 'api/digital/core/Customer/Register';
    this.restService.postUATData(params, url).subscribe(
      (data) => {
        if (data.rcode === 200) {
          this.oTPID = data.rObj?.authenticationUniqueCode;
          this.mfaAuthenticationTypeID = data.rObj.mfaAuthenticationTypeID;
          //  console.log(this.getMaskedEmail(),'email');
          let otpvalue = data.rObj.OTP;
          let otpToSet = data.rObj?.OTP?.toString();

          for (let i = 0; i < otpToSet.length; i++) {
            this.OTPForm.get('otp' + i)?.setValue(otpToSet[i]);
          }
          this.emaiauthentication = data.rObj?.message;
          this.loginBoolean = false;
          this.submitted = false;
          this.startTimer();
          this.loader.hide();
        } else {
          this.loader.hide();
          this.commonService.handleRcodeError(data);
        }
      },
      (error) => {
        this.loader.hide();
        if (
          error.error.rcode !== 401 &&
          error.error.rcode !== 403 &&
          error.error.rcode !== 404 &&
          error.error.rcode !== 500
        ) {
          this.commonService.handleStatusError(error);
        }
      }
    );
  }
  EmailFormSubmit() {
    this.submittedEmail = true;
    if (this.EmailForm.invalid) {
      return;
    }
    this.loader.show();
    let params: any = {};
    params.emailID = this.EmailForm.controls.email.value;
    (params.phoneNumber = null), (params.countryCodeID = null);
    let url = 'api/digital/core/Customer/Register';
    this.restService.postUATData(params, url).subscribe(
      (data) => {
        if (data.rcode === 200) {
          this.loader.hide();
          this.oTPID = data.rObj?.authenticationUniqueCode;
          this.mfaAuthenticationTypeID = data.rObj.mfaAuthenticationTypeID;
          //  console.log(this.getMaskedEmail(),'email');
          let otpToSet = data.rObj?.OTP?.toString();

          for (let i = 0; i < otpToSet.length; i++) {
            this.OTPForm.get('otp' + i)?.setValue(otpToSet[i]);
          }
          this.emaiauthentication = data.rObj?.message;
          this.loginBoolean = false;
          this.submitted = false;
          this.startTimer();
        } else {
          this.loader.hide();
          this.commonService.handleRcodeError(data);
        }
      },
      (error) => {
        this.loader.hide();
        if (
          error.error.rcode !== 401 &&
          error.error.rcode !== 403 &&
          error.error.rcode !== 404 &&
          error.error.rcode !== 500
        ) {
          this.commonService.handleStatusError(error);
        }
      }
    );
  }
  signInWithWhatsApp(): void {
    // let whatsappUrl: string = 'https://wa.me/919842642528?text=Hi%2C%20this%20is%20WhatsApp%20number%20%2B91919842642528';
    // let whatsappUrl: string = 'https://wa.me/918925599844?text=Hello%20Team,%20Please%20help%20me%20to%20sign%20in';
    // let whatsappUrl: string = 'https://wa.me/918925599844?text=Hello%20Team,%20Please%20help%20me%20to%20sign%20in';
    // let whatsappUrl: string = 'https://web.whatsapp.com/send?phone=918925599844&text=Hello%20Team,%20Please%20help%20me%20to%20sign%20in';
    // window.open(whatsappUrl, '_blank'); // Opens WhatsApp with the pre-filled message
    this.redirectToWhatsApp();
  }
  // Check if the user is on a mobile device
  redirectToWhatsApp() {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    var mobileLink = 'https://wa.me/918925599844?text=Hello%20Team,%20Please%20help%20me%20to%20sign%20in';
    var webLink = 'https://web.whatsapp.com/send?phone=918925599844&text=Hello%20Team,%20Please%20help%20me%20to%20sign%20in';

    // Redirect based on the device type
    let whatsappUrl = isMobile ? mobileLink : webLink;
    window.open(whatsappUrl, '_blank'); // Opens WhatsApp with the pre-filled message

  }

 // signInWithGoogle(): void { }
  async handleCredentialResponse(response: any) {
    // Here will be your response from Google.
    // console.log(response);
    const jwtToken = response.credential;
    const helper = new JwtHelperService();

    const decodedToken = helper.decodeToken(jwtToken);


    if (decodedToken.email_verified) {
      let val = {
        emailID: decodedToken?.email ?? null,
        fullName: decodedToken?.name ?? null,
      };

      this.handleGmailValidation(val);
    }
  }

  handleGmailValidation(val: any) {
    // this.isOnLoadAPI = false;
    let params = val;
    this.loader.show();
    this.restService.postUATAuthData(params, 'api/digital/core/Customer/LoginWithGmail')
      .subscribe({
        next: (data: any) => {
          if (data.rcode == 200) {
            this.authService.b2cAttemptAuth(data?.rObj?.token);
            this.toastr.success('Logged in successfully with Gmail!');
            this.dialogRef.close(true);
            this.loader.hide();

          } else {
            this.commonService.handleRcodeError(data);
            this.loader.hide();
          }
          // this.isOnLoadAPI = true;
        },
        error: (error: any) => {
          // this.isOnLoadAPI = true;
          this.loader.hide();
          this.commonService.checkStatusErrors(error);
        },
      });
  }

  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  getMasterCountryCode() {
    let params = {};
    let url = 'api/digital/core/Customer/FetchAllCountryCode';
    this.loader.show();
    this.restService.postUATData(params, url).subscribe(
      (data: any) => {
        this.loader.hide();
        if (data.rcode == 200) {
          this.phoneCodes = data.rObj.fetchMasterData;
          if (Array.isArray(this.phoneCodes) && this.phoneCodes?.length == 1) {
            this.MobileForm.controls.countryCode.setValue(
              this.phoneCodes[0]?.masterDataID
            );
          }
        } else {
          this.loader.hide();
          this.commonService.handleRcodeError(data);
        }
      },
      (error) => {
        this.loader.hide();
        this.commonService.handleStatusError(error);
        console.error(error);
      }
    );
  }
  signInPhoneNo() {
    this.MobileForm.controls.phoneNumber.setValue(null);
    this.MobileForm.controls.phoneNumber.clearValidators();
    this.MobileForm.controls.phoneNumber.updateValueAndValidity();
    this.EmailForm.controls.email.clearValidators();
    this.EmailForm.controls.email.setValue(null);
    this.EmailForm.controls.email.updateValueAndValidity();
    this.MobileHide = false;
    this.MobileForm.controls.phoneNumber.setValidators([
      Validators.required,
      Validators.minLength(9),
      Validators.maxLength(10),
    ]);
    this.MobileForm.controls.phoneNumber.updateValueAndValidity();
  }
  signInEmail() {
    this.MobileForm.controls.phoneNumber.setValue(null);
    this.MobileForm.controls.phoneNumber.clearValidators();
    this.MobileForm.controls.phoneNumber.updateValueAndValidity();
    this.EmailForm.controls.email.clearValidators();
    this.EmailForm.controls.email.setValue(null);
    this.EmailForm.controls.email.updateValueAndValidity();
    this.MobileHide = true;

    this.EmailForm.controls.email.setValidators([
      Validators.required,
      Validators.email,
      Validators.pattern(/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/),
    ]);
    this.EmailForm.controls.email.updateValueAndValidity();
  }
  otpSubmit() {
    this.getOtp();
    this.submittedotp = true;
    if (this.OTPForm.invalid) {
      return;
    }
    let params = {
      authenticationUniqueCode: this.oTPID,
      oTP: this.OTPForm.controls.otp?.value,
      mfaAuthenticationTypeID: this.mfaAuthenticationTypeID,
    };
    let url = 'api/digital/core/Customer/ValidateOTP';
    this.loader.show();
    this.restService.postUATData(params, url).subscribe(
      (data: any) => {
        this.loader.hide();
        if (data.rcode == 200) {
          // this.authService.customertempAuth(data.rObj.token);
          this.authService.b2cAttemptAuth(data.rObj.token);
          this.dialogRef.close(true);
          localStorage.setItem('customerLogin', data.rObj.token);

          // setTimeout(() => {
          //  this.router.navigate(['/quotes/view-buy-policy',this.quotationRequestID,this.quotationSearchID,id])

          // });
        } else {
          this.loader.hide();
          this.commonService.handleRcodeError(data);
        }
      },
      (error) => {
        this.loader.hide();
        this.commonService.handleStatusError(error);
        console.error(error);
      }
    );
  }
  startTimer() {
    this.stopCountdownTimer();
    this.resendCountdown = 60;
    this.timer = this.resendCountdown;
    this.remainingTime = this.timer;
    this.timeRemaining_percent = (this.remainingTime / this.timer) * 100;
    this.intervalId = setInterval(() => {
      this.remainingTime--;
      this.timeRemaining_percent = (this.remainingTime / this.timer) * 100;
      if (this.remainingTime <= 0) {
        this.stopCountdownTimer();
        this.showResend = true;
      }
    }, 1000);
  }

  stopCountdownTimer() {
    clearInterval(this.intervalId);
  }

  setFocusOnOTPInput() {
    setTimeout(() => {
      if (this.otpInput?.nativeElement) {
        this.renderer.selectRootElement(this.otpInput.nativeElement).focus();
      }
    }, 100);
  }

  pauseTimer() {
    clearInterval(this.interval);
  }
  onOtpInput(index: number) {
    const nextIndex = index + 1;
    this.otp = this.otp + this.OTPForm.controls['otp' + index].value;
    if (nextIndex < 6 && this.OTPForm.controls['otp' + index].value) {
      const input = <HTMLInputElement>(
        document.getElementById('otp' + nextIndex)
      );
      input.focus();
    }
  }
  onBackspaceKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === 'Backspace') {
      event.preventDefault();
      if (index >= 0) {
        this.OTPForm.controls['otp' + index].setValue(''); // Delete the previous item in the OTP array
        if (index > 0) {
          this.OTPForm.controls['otp' + (index - 1)].setValue('');
        }
        const previousInputId = 'otp' + (index - 1);
        const previousInputElement = document.getElementById(
          previousInputId
        ) as HTMLInputElement;
        if (previousInputElement) {
          previousInputElement.focus(); // Focus the previous input box
        }
      }
    }
  }
  onInputChange(event: Event, forWhat: string) {
    this.OTPForm.controls[forWhat].setValue(
      (event.target as HTMLInputElement).value.replace(/\D/g, '')
    );
  }
  getOtp() {
    let otp = '';
    for (let i = 0; i < 6; i++) {
      otp += this.OTPForm.controls['otp' + i].value;
    }
    this.OTPForm.controls['otp'].setValue(otp);
  }

  resendOtp() {
    let params: any = {};
    params.emailID = null;
    (params.phoneNumber = this.MobileForm.controls.phoneNumber.value),
      (params.countryCodeID = this.MobileForm.controls.countryCode.value);

    let url = 'api/digital/core/Customer/Register';
    this.loader.show();
    this.restService.postUATData(params, url).subscribe(
      (data: any) => {
        this.loader.hide();
        if (data.rcode == 200 || data.rcode == 203) {
          this.oTPID = data.rObj?.authenticationUniqueCode;
          //  console.log(this.getMaskedEmail(),'email');
          this.emaiauthentication = data.rObj?.message;
          this.loginBoolean = false;
          this.submitted = false;
          this.startTimer();
          this.setFocusOnOTPInput();
          this.showResend = false;
        } else {
          this.loader.hide();
          this.commonService.handleRcodeError(data);
        }
      },
      (error) => {
        this.loader.hide();
        this.commonService.handleStatusError(error);
        console.error(error);
      }
    );
  }
  goBack() {
    this.loader.show();
    this.submittedotp = false;
    for (let i = 0; i < 6; i++) {
      this.OTPForm.controls['otp' + i].setValue('');
    }
    this.loader.hide();
    this.loginBoolean = true;
  }
}
